import jsPDF from "jspdf";
import { autoTable } from 'jspdf-autotable';
import moment from "moment";
import visionLogo from "../../images/vision-logo.png";
import { mergePdfs } from "../helpers/pdfs";
import { addTrailingZeros } from "../helpers/common";

const generatePDF = async (warehouseData) => {
    const doc = new jsPDF('p', 'mm', 'a4');

    // Logo
    doc.addImage(visionLogo, "PNG", 8, 7, 44, 12);
    doc.setFontSize(16);
    doc.text("WarehouseSheet - Vision", 200, 12, { align: "right" })

    doc.setFontSize(12);
    doc.setTextColor("#787a80")
    doc.text(`Customer: ${warehouseData.CustomerCode}`, 15, 26);
    doc.text(`Date: ${moment(warehouseData.OrderDate, "YYYY-MM-DD").format("DD MMMM, YYYY")}`, 200, 26, { align: "right" });
    doc.setTextColor("#252527");

    // Product Details Table
    const products = warehouseData?.products;

    let productsHead = [["", "Qty", "Crate", "Count", "Price"]];

    productsHead[0].splice(1, 0, { content: "VisionProduce", colSpan: 2, fontStyle: "bold" });
    autoTable(doc, {
        startY: 30,
        columnStyles: {
            0: { cellWidth: 18, halign: "right" },
            1: { cellWidth: 22 },
            2: { cellWidth: 96 },
            3: { cellWidth: 16, halign: "center" },
            4: { cellWidth: 15, halign: "center" },
            5: { cellWidth: 15, halign: "center" },
            6: { cellWidth: 15, halign: "right" },
        },
        head: productsHead,
        body: products.map((product, productIndex) => {
            let agentCode = productIndex === 0 ? product.AgentCode : products[productIndex - 1].AgentCode !== product.AgentCode ? product.AgentCode : '';
            let ProductName = `${product.ProductName} ${product.ClassName || ''} ${product.SizeName || ''}`
            ProductName = ProductName?.replace(/\s+/g, ' ').trim();
            return ([agentCode, product.UnitName, ProductName, product.Qty ? addTrailingZeros(product.Qty) : '', product.ContainerName, "", ""])
        }),
        theme: "grid",
        headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            lineWidth: 0.2
        },
        styles: { fontSize: 11},
        margin: { top: 8, bottom: 8, left: 7, right: 7 },
        showHead: "firstPage",
    });

    // Check End of the Page and Move to new page if there no required space left.
    let yPosition = doc.lastAutoTable.finalY + 20;
    const pageHeight = doc.internal.pageSize.height;

    if (yPosition + 70 > pageHeight) {
        doc.addPage();
        yPosition = 10;
    }

    const maxWidth = 85;
    const OrderNotes = warehouseData.OrderNotes || "";
    const DeliveryInstructions = warehouseData.DeliveryInstructions || "";
    const PrintOrder = warehouseData.PrintOrder || "";
    let wrappedOrderNotes = doc.splitTextToSize(OrderNotes, maxWidth);
    let wrappedDeliveryInstructions = doc.splitTextToSize(DeliveryInstructions, maxWidth);
    let wrappedPrintOrder = doc.splitTextToSize(PrintOrder, maxWidth);

    // Summary Items
    doc.setFontSize(8);
    doc.setFont("helvetica", "bold");
    doc.text("UNITED", 10, yPosition);
    doc.text("8", 45, yPosition);
    doc.setFont("helvetica", "normal");
    doc.rect(50, yPosition - 5, 15, 8);

    doc.setFont("helvetica", "bold");
    doc.text("WACRATE", 10, yPosition + 10);
    doc.text("22", 44, yPosition + 10);
    doc.text("36", 44, yPosition + 20);
    doc.text("84", 44, yPosition + 30);
    doc.text("Bin", 43, yPosition + 40);
    doc.setFont("helvetica", "normal");
    doc.rect(50, yPosition + 5, 15, 8);
    doc.rect(50, yPosition + 15, 15, 8);
    doc.rect(50, yPosition + 25, 15, 8);
    doc.rect(50, yPosition + 35, 15, 8);

    doc.setFont("helvetica", "bold");
    doc.text("OTHER", 10, yPosition + 50);
    doc.text("M8", 43, yPosition + 50);
    doc.text("Pallets", 38, yPosition + 60);
    doc.setFont("helvetica", "normal");
    doc.rect(50, yPosition + 45, 15, 8);
    doc.rect(50, yPosition + 55, 15, 8);

    doc.setFont("helvetica", "bold");
    doc.text("Order Notes:", 75, yPosition);
    doc.setFont("helvetica", "normal");
    doc.rect(75, yPosition + 5, 60, 15);
    doc.text(wrappedOrderNotes, 76, yPosition + 9);

    doc.setFont("helvetica", "bold");
    doc.text("Items Count:", 140, yPosition);
    doc.text(`${products?.length - 10}`, 160, yPosition);

    doc.setFont("helvetica", "bold");
    doc.text("Delivery Instructions:", 75, yPosition + 30);
    doc.setFont("helvetica", "normal");
    doc.rect(75, yPosition + 35, 60, 15);
    doc.text(wrappedDeliveryInstructions, 76, yPosition + 39);

    doc.setFont("helvetica", "bold");
    doc.text("Print Name:", 140, yPosition + 30);
    doc.setFont("helvetica", "normal");
    doc.rect(140, yPosition + 35, 60, 15);
    doc.text(wrappedPrintOrder, 142, yPosition + 39);

    // Footer Pagination
    const totalPageCount = doc.internal.pages.length - 1;

    for (let i = 1; i <= totalPageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(8);
        doc.setTextColor("#787a80")
        const currentDate = moment().format("DD MMMM, YYYY")
        const pageText = `Page ${i} of ${totalPageCount}`;
        const visionText = `VISION PRODUCE`;
        if (i === totalPageCount) {
            doc.setDrawColor(0);
            doc.setLineWidth(0.5);
            doc.line(10, doc.internal.pageSize.height - 10, doc.internal.pageSize.width - 10, doc.internal.pageSize.height - 10);
            doc.text(
                currentDate,
                doc.internal.pageSize.getWidth() - 200,
                doc.internal.pageSize.getHeight() - 5,
            );
            doc.text(
                visionText,
                doc.internal.pageSize.getWidth() - 110,
                doc.internal.pageSize.getHeight() - 5,
            );
        }
        doc.text(
            pageText,
            doc.internal.pageSize.getWidth() - 25,
            doc.internal.pageSize.getHeight() - 5,
        );
    }

    return doc.output("arraybuffer");
}

export const generateWarehousePdf = async (warehouseDataArray) => {
    let fileName = 'Vision Product'
    const pdfs = [];
    for (const ele of warehouseDataArray) {
        const doc = await generatePDF(ele);
        pdfs.push(doc);
    }

    const mergedPdf = await mergePdfs(pdfs);
    const blob = new Blob([mergedPdf], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank');
}